import { render } from "./ActivitatEstadaCentreView.vue?vue&type=template&id=b0eafdd6&scoped=true"
import script from "./ActivitatEstadaCentreView.vue?vue&type=script&lang=js"
export * from "./ActivitatEstadaCentreView.vue?vue&type=script&lang=js"

import "./ActivitatEstadaCentreView.vue?vue&type=style&index=0&id=b0eafdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0eafdd6"]])

export default __exports__